import { CaseRunClient, CustomScalingBound, LabReportsTextsType } from '@app/api2/api';
import * as React from 'react';
import { Form, Tab, TextArea } from 'semantic-ui-react';
import { BPBoxWithHeader } from '@common/BPBoxWithHeader';
import { BPTabPane } from '@common/BPTabPane';
import { ErrorMessage, Field, Formik, useFormikContext } from 'formik';
import { ChangeObserver } from '@app/components/React/Labs/ChangeObserver';

interface ICustomScalingParameterEditorProps {
    labId: number,
    caseId: number,
    value?: string;
    readonly?: boolean;
    onChange?: (value) => void;
    useDeg?: boolean;
    useBwSt?: boolean;
    useFwSt?: boolean;
}

export const CustomScalingParameterEditor: React.FunctionComponent<ICustomScalingParameterEditorProps> = (props) => {
    const [bounds, setBounds] = React.useState<CustomScalingBound>()

    React.useEffect(() => {
        const parsedValue: CustomScalingBound = props.value ? JSON.parse(props.value) : {};
        setBounds(parsedValue);
    }, [props.value])

    const LowerUpperTr = (title, path, key?) => <tr key={key}>
        <td>{title}</td>
        <td>
            {props.readonly &&
                <Field name={`${path}.lower`}>
                    {({ field }) => (<div {...field}>{field.value}</div>)}
                </Field>
            }

            {!props.readonly &&
                <Field type="number" name={`${path}.lower`} />
            }
        </td>
        <td>
            {props.readonly &&
                <Field name={`${path}.upper`}>
                    {({ field }) => (<div {...field}>{field.value}</div>)}
                </Field>
            }

            {!props.readonly &&
                <Field type="number" name={`${path}.upper`} />
            }
        </td>
    </tr>
    return bounds != null && bounds.mx != null && <div>
        <Formik
            initialValues={{ ...bounds }}
            enableReinitialize={false}
            validate={values => {
                const errors = {} as any;
                // if (!values.email) {
                //   errors.email = 'Required';
                // } else if (
                //   !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                // ) {
                //   errors.email = 'Invalid email address';
                // }
                return errors;
            }}

            onSubmit={(values, { setSubmitting }) => {
                // setTimeout(() => {
                //     alert(JSON.stringify(values, null, 2));
                //     setSubmitting(false);
                // }, 400);
            }}>
            {({ isSubmitting, values }) => (
                <div>
                    <ChangeObserver value={values} onChange={(vals) => { props.onChange && props.onChange(JSON.stringify(vals)) }} />
                    <table>
                        <tbody>
                            {values?.mx?.map((mx, idx) => LowerUpperTr(idx, `mx[${idx}]`, `key${idx}`))}
                            {LowerUpperTr('Mu', 'mu')}
                            {LowerUpperTr('Sigma', 'sigma')}
                            {props.useDeg && LowerUpperTr('Beta', 'beta')}
                            {props.useBwSt && LowerUpperTr('Backward Stutter', 'xi')}
                            {props.useFwSt && LowerUpperTr('Forward Stutter', 'xiFw')}
                            <tr>
                                <td>{'Scale'}</td>
                                <td>
                                    {props.readonly &&
                                        <Field name={`scale`}>
                                            {({ field }) => (<div {...field}>{field.value}</div>)}
                                        </Field>
                                    }

                                    {!props.readonly &&
                                        <Field type="number" name={`scale`} />
                                    }
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

        </Formik>
    </div>
};
